const $ = jQuery.noConflict();
// import Parallax from 'parallax-js';
/* eslint-disable */
'use strict';
const ParallaxBanner = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBannerParallax: $('.js-banner-parallax'),

	/** @description Initialize */
	init: function() {
		if(window.innerWidth > 1199) {
			this.bannerParallax();
		}
	},

	bannerParallax: function() {
		const Parallax = require('parallax-js');
		const scene = $('.js-banner-parallax').get(0);
		if($('.js-banner-parallax').length > 0) {
			const parallax = new Parallax(scene);
		}
	}
};

export default ParallaxBanner;